<img src="../../../assets/images/login-close.svg" alt="" mat-dialog-close="" class="close-btn position-absolute">
<div class="px-3" style=" overflow: auto; max-height: 80vh;">
    <div class="row">
        <div class="col-md-12 privacy-content">
            <div *ngIf="privacyLoading" class="privacy-loading" aria-busy="true" aria-label="Loading privacy statement">
                <span class="privacy-loader-spinner"></span>
            </div>
            <ng-container *ngIf="!privacyLoading">
                <h4 class="fs-24 mb-3 fw-bold" *ngIf="!useCmsPrivacy">{{ privacyTitle }}</h4>
                <div *ngIf="useCmsPrivacy" class="privacy-cms-copy cms-content mb-0" [innerHTML]="privacyCopy | sanitizeHtml"></div>
                <div *ngIf="!useCmsPrivacy">
                    <ul *ngFor="let item of gdprPoints">
                        <li>{{ item?.policyPoint }}</li>
                    </ul>
                </div>
            </ng-container>
        </div>
        <div class="mt-3 ml-1" *ngIf="!privacyLoading && showPrivacyLink">
            <span>Find more information on Privacy here:
                <a [href]="privacyUrl" target="_blank" rel="noopener noreferrer">{{ privacyUrl }}</a>
            </span>
        </div>

        <div class="col-12">
            <div class="text-end">
                <button class="btn rounded-pill upload-btn text-white" (click)="submitGDPR()">Close</button>
            </div>
        </div>
    </div>
</div>
